<template>
	<div v-if="isVisible" class="trial-banner">
		<p v-if="userStore.user.subscription_platform_active === 'trial'">
			You're currently on a trial! Explore all our premium features.
		</p>
		<div v-else>
			You are on the free tier. To remove ads and get more features,
			<router-link to="/subscription">upgrade to the plus tier</router-link>.
		</div>
		<!-- <button @click="dismiss" class="dismiss-button">×</button> -->
	</div>
</template>

<script setup>
	import { computed } from "vue"
	import { useRoute, RouterLink } from "vue-router"
	import { useUserStore } from "@/stores/user"

	const userStore = useUserStore()
	const route = useRoute()

	const isVisible = computed(() => {
		const user = userStore.user
		return (
			((user &&
				user?.subscription_type !== "basic" &&
				user?.subscription_platform_active === "trial") ||
				(user && user?.subscription_type === "basic")) &&
			route.name !== "subscription"
		)
	})

	// function dismiss() {
	// 	isVisible.value = false
	// 	// Optionally, save the dismissed state to local storage
	// 	// localStorage.setItem('trialBannerDismissed', 'true');
	// }

	// Optionally, check local storage on component mount
	// if (localStorage.getItem('trialBannerDismissed') === 'true') {
	//   isVisible.value = false;
	// }
</script>

<style scoped>
	.trial-banner {
		background-color: #42b983; /* A pleasant green */
		color: white;
		padding: 10px 20px;
		text-align: center;
		position: relative;
		font-size: 0.9rem;
	}

	.trial-banner p {
		margin: 0;
		display: inline-block;
	}

	.dismiss-button {
		background: none;
		border: none;
		color: white;
		font-size: 1.2rem;
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
	}
</style>
